const ProgramDetailHeroSetup = () => {
  const components = document.querySelectorAll('[data-component-program-detail-hero]');

  components.forEach((component) => {
    const mainHeader = component.querySelector('.main-header');
    const heading = mainHeader.querySelector('.main-heading');
    const swiperContainer = component.querySelector('.swiper-container');
    let swiperInstance;

    function addCapitalLetterToBackground() {
      const letter = heading.textContent.charAt(0);
      const capital = document.createElement('span');
      capital.innerText = letter;
      capital.classList.add('capital');
      mainHeader.prepend(capital);
    }

    const init = () => {
      const galleryId = swiperContainer.getAttribute('id');
      console.log(galleryId);
      swiperInstance = new Swiper(`#${galleryId}`, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: `.swiper-button-next-${galleryId}`,
          prevEl: `.swiper-button-prev-${galleryId}`,
        },
      });
    };

    if (swiperContainer) {
      init();
    }

    const handleWindowResize = () => {
      if (swiperInstance) {
        swiperInstance.destroy();
        init();
      }
    };

    window.addEventListener('resize', () => handleWindowResize());

    addCapitalLetterToBackground();
  });
};

ProgramDetailHeroSetup();